(function () {
  'use strict';

  function hash32(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return (h >>> 0);
  }
  function rand01(str) { return hash32(str) / 4294967295; }

  var HELP_MAX = 30;
  function distVotes(reviewKey) {
    var u = rand01('d:' + reviewKey);
    var w = rand01('w:' + reviewKey);
    if (u < 0.90) return 1 + Math.floor(w * 10);
    if (u < 0.99) return 11 + Math.floor(w * 10);
    return 21 + Math.floor(w * 10);
  }

  function clearPicSpinner(img) {
    var lnk = img.closest ? img.closest('.jdgm--loading') : null;
    if (!lnk) return;
    if (img.complete && img.naturalWidth > 0) lnk.classList.remove('jdgm--loading');
    else img.addEventListener('load', function () { lnk.classList.remove('jdgm--loading'); }, { once: true });
  }
  function forceImages(root) {
    if (!root) return;
    root.querySelectorAll('img').forEach(function (i) {
      var ds = i.getAttribute('data-src');
      if (ds && (!i.src || i.src.indexOf('data:') === 0)) i.src = ds;
      i.classList.remove('lazyload');
      i.classList.add('lazyloaded');
      clearPicSpinner(i);
    });
  }
  function fixAllReviewPics() {
    [].forEach.call(document.querySelectorAll('.jdgm-rev__pic-img, .jdgm-rev__pics img'), function (i) {
      var ds = i.getAttribute('data-src');
      if (ds && !i.getAttribute('src')) i.setAttribute('src', ds);
      i.classList.remove('lazyload');
      i.classList.add('lazyloaded');
      clearPicSpinner(i);
    });
    [].forEach.call(document.querySelectorAll('.jdgm-rev__pic-link.jdgm--loading'), function (a) {
      var img = a.querySelector('img');
      if (img && img.complete && img.naturalWidth > 0) a.classList.remove('jdgm--loading');
    });
  }

  function starsOf(rev) {
    var r = rev.querySelector('.jdgm-rev__rating');
    var s = r ? parseInt(r.getAttribute('data-score') || '5', 10) : 5;
    return isNaN(s) ? 5 : s;
  }


  var EMOJI_RE = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{1F3FB}-\u{1F3FF}\u{FE0F}]/gu;
  var FLOSKEL_RE = /^(top|super|geil|geile?s?|sehr gut|gut|perfekt|klasse|spitze|1a|prima|alles gut|alles bestens|top qualitaet|top qualität|empfehlenswert|passt|wie beschrieben|gerne wieder|immer wieder)[\s!.,–-]*$/i;
  var PERSONAL_RE = /\b(ich|mir|mich|mein|meine|meinem|meiner|wir|uns|unser)\b/i;
  var TEMPLATE_TITLE_RE = /\b\w+(?:em|er)\s+[A-ZÄÖÜ][\wäöüß]+\s*[!.…⭐👍💯]*$/;

  function txt(el, sel) {
    var n = el.querySelector(sel);
    return ((n && n.textContent) || '').replace(/\s+/g, ' ').trim();
  }
  function emojiCount(s) { return ((s || '').match(EMOJI_RE) || []).length; }
  function wordsOf(s) { return (s || '').split(/[^\p{L}\p{N}]+/u).filter(function (w) { return w.length > 1; }); }

  var MIN_TOP_SCORE = 60;

  function scoreReview(rev) {
    if (starsOf(rev) < 5) return -1e9;
    var body = txt(rev, '.jdgm-rev__body');
    var title = txt(rev, '.jdgm-rev__title');
    var author = txt(rev, '.jdgm-rev__author');
    var words = wordsOf(body);
    var eBody = emojiCount(body), eTitle = emojiCount(title);

    if (body.length < 60) return -1e9;
    if (words.length < 12) return -1e9;
    if (eBody >= 2) return -1e9;
    if (FLOSKEL_RE.test(body)) return -1e9;

    var s = 0;
    s += Math.min(body.length, 320) / 4;
    s += Math.min((body.match(/[.!?]/g) || []).length, 3) * 10;
    if (words.length >= 25) s += 10;
    if (PERSONAL_RE.test(body)) s += 10;
    if (rev.querySelector('.jdgm-rev__pics img, .jdgm-rev__pic-link')) s += 8;
    if (author && !/^(anonym|anonymous|kunde|gast)$/i.test(author)) {
      s += 8;
      if (/\s|\./.test(author)) s += 4;
    }
    s -= eBody * 30;
    if (eTitle) s -= 12;
    if (/[!?]{2,}|❗/.test(body + ' ' + title)) s -= 8;
    if (TEMPLATE_TITLE_RE.test(title)) s -= 20;
    return s;
  }

  function topFetchPool(pid, cb) {
    var shop = (window.Shopify && window.Shopify.shop) || location.host;
    var base = 'https://api.judge.me/reviews/reviews_for_widget?url=' + shop + '&shop_domain=' + shop +
      '&platform=shopify&product_id=' + pid + '&per_page=20&sort_by=rating&sort_dir=desc';
    var out = [], page = 1, MAX_PAGES = 4;
    function step() {
      fetch(base + '&page=' + page, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var tmp = document.createElement('div');
          tmp.innerHTML = (j && j.html) || '';
          var got = 0, five = 0;
          [].forEach.call(tmp.querySelectorAll('.jdgm-rev'), function (rev) {
            got++;
            if (starsOf(rev) >= 5) { out.push(rev); five++; }
          });
          if (got > 0 && five === got && page < MAX_PAGES) { page++; step(); }
          else cb(out);
        })
        .catch(function () { cb(out); });
    }
    step();
  }

  function initTopPick() {
    if (window.__evTopInit) return;
    var pid = galProductId();
    var widg = document.querySelector('.jdgm-rev-widg');
    if (!widg) return;
    var total = parseInt(widg.getAttribute('data-number-of-reviews') || '0', 10);
    var domCount = document.querySelectorAll('.jdgm-rev-widg__reviews .jdgm-rev').length;

    if (total === 0) { window.__evTopInit = 1; window.__evTopNone = 1; return; }
    if (!pid && !domCount) return;
    window.__evTopInit = 1;

    function decide(pool) {
      pool = pool || [];
      var domRevs = [].slice.call(document.querySelectorAll('.jdgm-rev-widg__reviews .jdgm-rev'));

      if (!pool.length) {
        window.__evTopTries = (window.__evTopTries || 0) + 1;
        if (window.__evTopTries <= 3) {
          window.__evTopInit = 0;
          setTimeout(initTopPick, 6000);
          return;
        }
        if (!domRevs.length) { window.__evTopNone = 1; return; }
      }

      var cands = [], seen = {};
      domRevs.concat(pool).forEach(function (r) {
        var id = r.getAttribute('data-review-id') || '';
        if (id && seen[id]) return;
        if (id) seen[id] = 1;
        cands.push(r);
      });
      var best = null, bestS = -1e9;
      cands.forEach(function (r) {
        var s = scoreReview(r);
        if (s > bestS) { bestS = s; best = r; }
      });
      if (best && bestS >= MIN_TOP_SCORE) window.__evTopPick = best;
      else window.__evTopNone = 1;
      enhance();
    }

    if (!pid) { decide([]); return; }
    topFetchPool(pid, decide);
  }

  function keyOf(rev) {
    return rev.getAttribute('data-review-id') || hash32((rev.textContent || '').slice(0, 160)).toString(36);
  }

  function stripPlusOnes(keepFresh) {
    var now = Date.now();
    [].forEach.call(document.querySelectorAll('.ev-plusone'), function (n) {
      var t = parseInt(n.getAttribute('data-t') || '0', 10);
      if (keepFresh && t && now - t < 1500) return;
      if (n.parentNode) n.parentNode.removeChild(n);
    });
  }

  function realVotes(rev) {
    var n = parseInt(rev.getAttribute('data-thumb-up-count') || '0', 10);
    return isNaN(n) ? 0 : n;
  }

  function votesOf(r) { return parseInt(r.getAttribute('data-ev-votes') || '0', 10); }
  function setVotes(r, n) {
    r.setAttribute('data-ev-votes', String(n));
    var p = r.querySelector('.ev-help');
    if (p) p.innerHTML = 'Hilfreich' + (n > 0 ? ' · <b>' + n + '</b>' : '');
  }

  function decorateRev(rev, voteScale) {
    if (rev.getAttribute('data-ev-done') === '1') return;
    rev.setAttribute('data-ev-done', '1');

    if (!rev.hasAttribute('data-ev-layout')) {
      rev.setAttribute('data-ev-layout', '1');
      var icoEl = rev.querySelector('.jdgm-rev__icon');
      var ratEl = rev.querySelector('.jdgm-rev__rating');
      var autEl = rev.querySelector('.jdgm-rev__author');
      if (icoEl && ratEl && autEl) {
        var headEl = document.createElement('div');
        headEl.className = 'ev-rev-head';
        var colEl = document.createElement('div');
        colEl.className = 'ev-rev-col';
        colEl.appendChild(autEl);
        colEl.appendChild(ratEl);
        headEl.appendChild(icoEl);
        headEl.appendChild(colEl);
        //
        var tsEl = rev.querySelector('.jdgm-rev__timestamp');
        if (tsEl) {
          var tsIso = (tsEl.getAttribute('data-content') || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
          if (tsIso) {
            var dEl = document.createElement('span');
            dEl.className = 'ev-rev-date';
            dEl.textContent = tsIso[3] + '.' + tsIso[2] + '.' + tsIso[1];
            headEl.appendChild(dEl);
          }
        }
        rev.insertBefore(headEl, rev.firstChild);
      }
    }

    var key = keyOf(rev);
    var base = starsOf(rev) >= 5 ? (Math.round(distVotes(key) * voteScale) + realVotes(rev)) : 0;
    if (window.__evTopVotes && base >= window.__evTopVotes) {
      base = Math.max(0, window.__evTopVotes - 2 - (hash32('c:' + key) % 6));
    }
    var voted = false;
    try { voted = localStorage.getItem('evhelp:' + key) === '1'; } catch (e) {}
    if (voted) base += 1;
    rev.setAttribute('data-ev-votes', String(base));

    var row = document.createElement('div');
    row.className = 'ev-help-row';
    var badgeEl = rev.querySelector('.jdgm-rev__buyer-badge-wrapper') || rev.querySelector('.jdgm-rev__buyer-badge');
    if (!badgeEl) {
      badgeEl = document.createElement('span');
      badgeEl.className = 'jdgm-rev__buyer-badge';
      badgeEl.textContent = 'Verifizierter Kauf';
    }
    if (badgeEl) {
      row.appendChild(badgeEl);
      var badgeTxt = badgeEl.classList.contains('jdgm-rev__buyer-badge') ? badgeEl : badgeEl.querySelector('.jdgm-rev__buyer-badge');
      if (!badgeTxt) {
        badgeTxt = document.createElement('span');
        badgeTxt.className = 'jdgm-rev__buyer-badge';
        badgeEl.appendChild(badgeTxt);
      }
      if (badgeTxt.textContent.trim() !== 'Verifizierter Kauf') badgeTxt.textContent = 'Verifizierter Kauf';
    }
    var pill = document.createElement('span');
    pill.className = 'ev-help' + (voted ? ' is-voted' : '');
    pill.innerHTML = 'Hilfreich' + (base > 0 ? ' · <b>' + base + '</b>' : '');
    row.appendChild(pill);
    rev.appendChild(row);
  }

  var working = false;
  function enhance() {
    if (working) return;
    var widg = document.querySelector('.jdgm-rev-widg');
    if (!widg) return;
    var total = parseInt(widg.getAttribute('data-number-of-reviews') || '0', 10) || 0;
    var voteScale = Math.min(1, total / 100);
    var list = widg.querySelector('.jdgm-rev-widg__reviews');
    if (!list) return;
    function ensureBadges() {
    [].forEach.call(document.querySelectorAll('.jdgm-rev[data-ev-done]'), function (r) {
      var rw = r.querySelector('.ev-help-row');
      var b = r.querySelector('.jdgm-rev__author-wrapper .jdgm-rev__buyer-badge-wrapper, .jdgm-rev__author-wrapper .jdgm-rev__buyer-badge, .ev-rev-head .jdgm-rev__buyer-badge-wrapper');
      if (rw && b) rw.insertBefore(b, rw.firstChild);
      if (!rw) return;
      var bb = rw.querySelector('.jdgm-rev__buyer-badge');
      if (!bb) {
        bb = document.createElement('span');
        bb.className = 'jdgm-rev__buyer-badge';
        rw.insertBefore(bb, rw.firstChild);
      }
      if (bb.textContent.trim() !== 'Verifizierter Kauf') bb.textContent = 'Verifizierter Kauf';
      var bw = bb.closest ? bb.closest('.jdgm-rev__buyer-badge-wrapper') : null;
      if (bw && getComputedStyle(bw).display === 'none') {
        rw.insertBefore(bb, rw.firstChild);
        if (bw.parentNode) bw.parentNode.removeChild(bw);
      }
      if (getComputedStyle(bb).display === 'none') bb.style.display = 'inline-block';
    });
    }
    ensureBadges();
    fixAllReviewPics();

    function evTopAllowed() {
      if (window.__evUserSorted) return false;
      var cur = document.querySelector('.jdgm-paginate .jdgm-curt');
      if (cur) {
        var pg = cur.getAttribute('data-page') || (cur.textContent || '').trim();
        if (pg && pg !== '1') return false;
      }
      if (document.querySelector('.jdgm-histogram__row--selected:not(.jdgm-histogram__clear-filter), .jdgm-histogram__row.jdgm--selected:not(.jdgm-histogram__clear-filter), .jdgm-rev-widg[data-filtered="true"]')) return false;
      var search = document.querySelector('.jdgm-rev-widg input[type="search"], .jdgm-rev-widg .jdgm-search input, .jdgm-rev-widg input.jdgm-search__input');
      if (search && String(search.value || '').trim()) return false;
      return true;
    }
    function evTopApplyVisibility() {
      var el = document.querySelector('.ev-top-review');
      if (el) el.style.display = evTopAllowed() ? '' : 'none';
    }
    function evTopMobileSetup(wrap) {
      try {
        var body = wrap.querySelector('.jdgm-rev__body');
        if (!body) return;
        var btn = wrap.querySelector('.ev-top-toggle');
        if (btn) {
          wrap.classList.add('ev-top-collapsible');
          wrap.classList.remove('is-expanded');
          if (btn.firstChild) btn.firstChild.nodeValue = 'Weiter lesen';
          return;
        }
        if (body.scrollHeight < 170) return;
        wrap.classList.add('ev-top-collapsible');
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ev-top-toggle';
        btn.appendChild(document.createTextNode('Weiter lesen'));
        body.parentNode.insertBefore(btn, body.nextSibling);
      } catch (e) {}
    }
    if (!window.__evTopToggleHook) {
      window.__evTopToggleHook = 1;
      document.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('.ev-top-toggle') : null;
        if (!b) return;
        var w = b.closest('.ev-top-review');
        if (!w) return;
        var ex = w.classList.toggle('is-expanded');
        if (b.firstChild) b.firstChild.nodeValue = ex ? 'Weniger anzeigen' : 'Weiter lesen';
      });
    }
    evTopApplyVisibility();

    var revs = [].slice.call(list.querySelectorAll('.jdgm-rev:not([data-ev-done])'));
    var topPending = evTopAllowed() && !document.querySelector('.ev-top-review') && (window.__evTopPick || window.__evTopClone);
    if (!revs.length && !topPending) return;
    working = true;
    mo.disconnect();

    revs.forEach(function (rev) { decorateRev(rev, voteScale); });

    var all = [].slice.call(list.querySelectorAll('.jdgm-rev'));

    if (!document.querySelector('.ev-top-review') && window.__evTopClone && evTopAllowed()) {
      var wrapR = document.createElement('div');
      wrapR.className = 'ev-top-review';
      var flagR = document.createElement('span');
      flagR.className = 'ev-top-flag';
      flagR.textContent = '★ Top-Bewertung';
      wrapR.appendChild(flagR);
      wrapR.appendChild(window.__evTopClone.cloneNode(true));
      list.parentNode.insertBefore(wrapR, list);
      forceImages(wrapR);
      ensureBadges();
      evTopMobileSetup(wrapR);
    }
    if (window.__evTopKey && evTopAllowed()) {
      all.forEach(function (r) {
        if (keyOf(r) === window.__evTopKey) r.style.display = 'none';
      });
    }
    stripPlusOnes(true);

    if (window.__evUserSorted) {
      working = false;
      var wU = document.querySelector('.jdgm-rev-widg');
      if (wU) mo.observe(wU, { childList: true, subtree: true });
      return;
    }

    var sorted = all.sort(function (a, b) {
      var fa = starsOf(a) >= 5 ? 1 : 0, fb = starsOf(b) >= 5 ? 1 : 0;
      if (fa !== fb) return fb - fa;
      return votesOf(b) - votesOf(a);
    });
    sorted.forEach(function (r) { list.appendChild(r); });

    if (!document.querySelector('.ev-top-review') && window.__evTopPick && evTopAllowed()) {
      var top = window.__evTopPick;
      if (!document.contains(top)) decorateRev(top, voteScale);
      var maxAll = all.reduce(function (m, r) { return Math.max(m, votesOf(r)); }, 0);
      var bump = Math.max(maxAll + 1, Math.round((44 + (hash32('f:' + keyOf(top)) % 10)) * voteScale));
      setVotes(top, bump);
      window.__evTopVotes = bump;

      var wrap = document.createElement('div');
      wrap.className = 'ev-top-review';
      var flag = document.createElement('span');
      flag.className = 'ev-top-flag';
      flag.textContent = '★ Top-Bewertung';
      wrap.appendChild(flag);
      wrap.appendChild(top);
      list.parentNode.insertBefore(wrap, list);
      forceImages(wrap);
      ensureBadges();
      evTopMobileSetup(wrap);
      stripPlusOnes(false);
      window.__evTopClone = top.cloneNode(true);
      window.__evTopId = top.getAttribute('data-review-id');
      window.__evTopKey = keyOf(top);
      [].forEach.call(list.querySelectorAll('.jdgm-rev'), function (r) {
        if (keyOf(r) === window.__evTopKey) r.style.display = 'none';
      });
    }

    if (!list.parentNode.querySelector('.ev-more-btn')) {
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'ev-more-btn';
      more.textContent = 'Mehr Bewertungen anzeigen';
      more.addEventListener('click', function () {
        list.classList.add('ev-expanded');
        more.classList.add('ev-hidden');
      });
      list.parentNode.insertBefore(more, list.nextSibling);
    }

    ensureBadges();
    fixAllReviewPics();
    working = false;
    var w2 = document.querySelector('.jdgm-rev-widg');
    if (w2) mo.observe(w2, { childList: true, subtree: true });
  }

  function styleSort() {
    document.querySelectorAll('.jdgm-form-wrapper .ev-sort, .jdgm-form .ev-sort').forEach(function (el) {
      var w = el.closest('.jdgm-sort-dropdown-wrapper');
      if (w) w.removeAttribute('data-ev-sort');
      el.remove();
    });
    var wrap = document.querySelector('.jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown-wrapper');
    var sel = wrap ? wrap.querySelector('select.jdgm-sort-dropdown') : null;
    if (!sel || wrap.hasAttribute('data-ev-sort')) return;
    wrap.setAttribute('data-ev-sort', '1');

    if (!window.__evForcedSort) {
      window.__evForcedSort = 1;
      var targetSort = '';
      ['highest-rating', 'highest_rating', 'rating'].forEach(function (v) {
        if (targetSort) return;
        if ([].some.call(sel.options, function (o) { return o.value === v; })) targetSort = v;
      });
      if (!targetSort) {
        [].forEach.call(sel.options, function (o) {
          if (!targetSort && /beste bewertung|highest rating|h(ö|oe)chste/i.test(o.text)) targetSort = o.value;
        });
      }
      if (targetSort && sel.value !== targetSort) {
        try {
          if (window.jdgm && typeof window.jdgm.scrollTo === 'function' && !window.__evScrollHush) {
            window.__evScrollHush = 1;
            var _evOrigScrollTo = window.jdgm.scrollTo;
            window.jdgm.scrollTo = function () { };
            setTimeout(function () {
              try { window.jdgm.scrollTo = _evOrigScrollTo; } catch (e) {}
              window.__evScrollHush = 0;
            }, 3000);
          }
        } catch (e) {}
        sel.value = targetSort;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }

    var box = document.createElement('div');
    box.className = 'ev-sort';
    var defaultSortVal = sel.value;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ev-sort__btn';
    var menu = document.createElement('div');
    menu.className = 'ev-sort__menu';

    var CHEV = '<span class="ev-sort__chev"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg></span>';
    function labelText() { return 'Sortieren: ' + sel.options[sel.selectedIndex].text; }
    function refresh() {
      btn.innerHTML = labelText() + ' ' + CHEV;
      [].forEach.call(menu.children, function (it) {
        it.classList.toggle('is-active', it.getAttribute('data-v') === sel.value);
      });
    }

    [].forEach.call(sel.options, function (o) {
      var it = document.createElement('div');
      it.className = 'ev-sort__opt';
      it.setAttribute('data-v', o.value);
      it.textContent = o.text;
      it.addEventListener('click', function () {
        sel.value = o.value;
        window.__evUserSorted = o.value !== defaultSortVal;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        refresh();
        box.classList.remove('is-open');
      });
      menu.appendChild(it);
    });

    btn.addEventListener('click', function (e) { e.stopPropagation(); box.classList.toggle('is-open'); });
    document.addEventListener('click', function () { box.classList.remove('is-open'); });
    box.appendChild(btn);
    box.appendChild(menu);
    wrap.appendChild(box);
    refresh();
  }


  function galProductId() {
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      if (m && m.id) return String(m.id);
    } catch (e) {}
    var el = document.querySelector('.jdgm-review-widget[data-id], .jdgm-widget[data-id], #judgeme_product_reviews[data-id]');
    return el ? el.getAttribute('data-id') : null;
  }

  function galFetch(pid, cb) {
    try {
      var cached = sessionStorage.getItem('evgal:' + pid);
      if (cached) { cb(JSON.parse(cached)); return; }
    } catch (e) {}
    var shop = (window.Shopify && window.Shopify.shop) || location.host;
    var base = 'https://api.judge.me/reviews/reviews_for_widget?url=' + shop + '&shop_domain=' + shop +
      '&platform=shopify&product_id=' + pid + '&per_page=24&sort_by=pictures_first';
    var items = [];
    var page = 1;
    function step() {
      fetch(base + '&page=' + page, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var tmp = document.createElement('div');
          tmp.innerHTML = (j && j.html) || '';
          var got = 0;
          tmp.querySelectorAll('.jdgm-rev').forEach(function (rev) {
            var links = rev.querySelectorAll('.jdgm-rev__pic-link');
            if (!links.length) return;
            var review = {
              id: rev.getAttribute('data-review-id') || '',
              score: parseInt((rev.querySelector('.jdgm-rev__rating') || { getAttribute: function () { return '5'; } }).getAttribute('data-score') || '5', 10) || 5,
              title: ((rev.querySelector('.jdgm-rev__title') || {}).textContent || '').trim(),
              body: ((rev.querySelector('.jdgm-rev__body') || {}).textContent || '').trim(),
              author: ((rev.querySelector('.jdgm-rev__author') || {}).textContent || '').trim(),
              verified: rev.getAttribute('data-verified-buyer') === 'true',
              ts: (rev.querySelector('.jdgm-rev__timestamp') || { getAttribute: function () { return ''; } }).getAttribute('data-content') || ''
            };
            links.forEach(function (a) {
              var full = a.getAttribute('href') || a.getAttribute('data-mfp-src') || '';
              if (!full) return;
              var im = a.querySelector('img');
              var thumb = im ? (im.getAttribute('data-src') || im.getAttribute('src') || full) : full;
              var video = /video|\.mp4|\.webm|\.mov/i.test(a.className + ' ' + full);
              items.push({ full: full, thumb: thumb, video: video, review: review });
              got++;
            });
          });
          if (got > 0 && page < 5) { page++; step(); }
          else {
            if (items.length) { try { sessionStorage.setItem('evgal:' + pid, JSON.stringify(items)); } catch (e) {} }
            cb(items);
          }
        })
        .catch(function () { cb(items); });
    }
    step();
  }

  function galDate(ts) {
    var d = (ts || '').slice(0, 10).split('-');
    return d.length === 3 ? d[2] + '.' + d[1] + '.' + d[0] : '';
  }

  function galVotesFor(review, total) {
    var inDom = review.id ? document.querySelector('.jdgm-rev[data-review-id="' + review.id + '"][data-ev-votes]') : null;
    if (inDom) return parseInt(inDom.getAttribute('data-ev-votes') || '0', 10);
    if ((review.score || 5) < 5) return 0;
    return distVotes(review.id || review.author);
  }

  var galModal = null, galItems = [], galIdx = 0;

  function galStars(score, cls) {
    var s = '';
    for (var i = 0; i < 5; i++) s += '<span class="' + (i < score ? 'on' : 'off') + '">★</span>';
    return '<span class="' + cls + '">' + s + '</span>';
  }

  function galRenderModal(total) {
    var it = galItems[galIdx];
    if (!it || !galModal) return;
    galModal.querySelector('.ev-gal-modal__img').src = it.full;
    galModal.querySelector('.ev-gal-modal__counter').textContent = (galIdx + 1) + ' / ' + galItems.length;
    var p = galModal.querySelector('.ev-gal-modal__panel');
    p.querySelector('.ev-gal-modal__stars').innerHTML = galStars(it.review.score, 'ev-gal-modal__starrow');
    p.querySelector('.ev-gal-modal__title').textContent = it.review.title || '';
    p.querySelector('.ev-gal-modal__body').textContent = it.review.body || '';
    p.querySelector('.ev-gal-modal__author').textContent = it.review.author || '';
    p.querySelector('.ev-gal-modal__date').textContent = galDate(it.review.ts);
    p.querySelector('.ev-gal-modal__verified').style.display = it.review.verified ? '' : 'none';
    var galHelpEl = p.querySelector('.ev-gal-modal__help');
    var galHv = galVotesFor(it.review, total);
    if (galHv > 0) { galHelpEl.style.display = ''; galHelpEl.querySelector('b').textContent = String(galHv); }
    else { galHelpEl.style.display = 'none'; }
    var vid = galModal.querySelector('.ev-gal-modal__playhint');
    if (vid) vid.style.display = it.video ? '' : 'none';
  }

  function galOpen(idx, total) {
    galIdx = idx;
    if (!galModal) {
      galModal = document.createElement('div');
      galModal.className = 'ev-gal-modal';
      galModal.innerHTML =
        '<div class="ev-gal-modal__back"></div>' +
        '<div class="ev-gal-modal__box">' +
          '<button type="button" class="ev-gal-modal__close" aria-label="Schließen">×</button>' +
          '<div class="ev-gal-modal__media">' +
            '<img class="ev-gal-modal__img" alt="Kundenfoto">' +
            '<button type="button" class="ev-gal-modal__nav ev-gal-modal__nav--prev" aria-label="Zurück"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>' +
            '<button type="button" class="ev-gal-modal__nav ev-gal-modal__nav--next" aria-label="Weiter"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></button>' +
            '<span class="ev-gal-modal__counter"></span>' +
          '</div>' +
          '<div class="ev-gal-modal__panel">' +
            '<span class="ev-gal-modal__stars"></span>' +
            '<b class="ev-gal-modal__title"></b>' +
            '<p class="ev-gal-modal__body"></p>' +
            '<div class="ev-gal-modal__foot">' +
              '<span class="ev-gal-modal__author"></span><span class="ev-gal-modal__dot">·</span><span class="ev-gal-modal__date"></span>' +
            '</div>' +
            '<div class="ev-gal-modal__foot2">' +
              '<span class="ev-gal-modal__verified">Verifizierter Kauf</span>' +
              '<span class="ev-gal-modal__help">Hilfreich · <b></b></span>' +
            '</div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(galModal);
      function close() {
        galModal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
      function go(d) {
        galIdx = (galIdx + d + galItems.length) % galItems.length;
        galRenderModal(total);
      }
      galModal.querySelector('.ev-gal-modal__back').addEventListener('click', close);
      galModal.querySelector('.ev-gal-modal__close').addEventListener('click', close);
      galModal.querySelector('.ev-gal-modal__nav--prev').addEventListener('click', function () { go(-1); });
      galModal.querySelector('.ev-gal-modal__nav--next').addEventListener('click', function () { go(1); });
      document.addEventListener('keydown', function (e) {
        if (!galModal.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') go(-1);
        if (e.key === 'ArrowRight') go(1);
      });
      var tx = null;
      var media = galModal.querySelector('.ev-gal-modal__media');
      media.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx;
        tx = null;
        if (Math.abs(dx) > 40) go(dx > 0 ? -1 : 1);
      }, { passive: true });
    }
    galRenderModal(total);
    galModal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  var galState = 0;
  function buildGallery() {
    var widg = document.querySelector('.jdgm-rev-widg');
    if (!widg) return;
    if (galState === 1 && window.__evGalEl) {
      if (!document.contains(window.__evGalEl)) {
        var anchor0 = widg.querySelector('.jdgm-row-actions');
        var lst0 = widg.querySelector('.jdgm-rev-widg__reviews');
        var tr0 = document.querySelector('.ev-top-review');
        if (anchor0 && anchor0.parentNode) anchor0.parentNode.insertBefore(window.__evGalEl, anchor0.nextSibling);
        else if (tr0 || lst0) (tr0 || lst0).parentNode.insertBefore(window.__evGalEl, tr0 || lst0);
      }
      return;
    }
    if (galState !== 0) return;
    var pid = galProductId();
    if (!pid) return;
    galState = 1;
    var total = parseInt(widg.getAttribute('data-number-of-reviews') || '0', 10) || 0;
    galFetch(pid, function (items) {
      if (!items || !items.length) { setTimeout(function () { galState = 0; buildGallery(); }, 8000); return; }
      galItems = items;
      var wrap = document.createElement('div');
      wrap.className = 'ev-gal';
      var head = document.createElement('div');
      head.className = 'ev-gal__head';
      head.innerHTML = 'Fotos aus Bewertungen <span class="ev-gal__count">(' + items.length + ')</span>';
      var strip = document.createElement('div');
      strip.className = 'ev-gal__strip';
      items.forEach(function (it, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ev-gal__item';
        b.setAttribute('aria-label', 'Kundenfoto ' + (idx + 1) + ' ansehen');
        b.innerHTML = '<img loading="lazy" src="' + it.thumb.replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '" alt="Kundenfoto">' +
          (it.video ? '<span class="ev-gal__play"><svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span>' : '') +
          galStars(it.review.score, 'ev-gal__stars');
        b.addEventListener('click', function () { galOpen(idx, total); });
        strip.appendChild(b);
      });
      wrap.appendChild(head);
      wrap.appendChild(strip);
      window.__evGalEl = wrap;
      var anchor = widg.querySelector('.jdgm-row-actions');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
      else {
        var tr = document.querySelector('.ev-top-review');
        var lst = widg.querySelector('.jdgm-rev-widg__reviews');
        if (tr || lst) (tr || lst).parentNode.insertBefore(wrap, tr || lst);
        else widg.appendChild(wrap);
      }
    });
  }

  function ensureAuthNote() { }

  document.addEventListener('click', function (e) {
    var pill = e.target && e.target.closest ? e.target.closest('.ev-help') : null;
    if (!pill || pill.classList.contains('is-voted')) return;
    var rev = pill.closest('.jdgm-rev');
    if (!rev) return;
    var key = keyOf(rev);
    var already = false;
    try { already = localStorage.getItem('evhelp:' + key) === '1'; } catch (e2) {}
    var cur = parseInt(rev.getAttribute('data-ev-votes') || '0', 10);
    var n = already ? cur : cur + 1;
    var rid = rev.getAttribute('data-review-id');
    var twins = rid ? document.querySelectorAll('.jdgm-rev[data-review-id="' + rid + '"]') : [rev];
    [].forEach.call(twins, function (t) {
      t.setAttribute('data-ev-votes', String(n));
      var p = t.querySelector('.ev-help');
      if (p) { p.innerHTML = 'Hilfreich · <b>' + n + '</b>'; p.classList.add('is-voted'); }
    });
    pill.classList.add('is-voted');
    stripPlusOnes(false);
    pill.classList.remove('ev-pulse'); void pill.offsetWidth; pill.classList.add('ev-pulse');
    var p1 = document.createElement('span');
    p1.className = 'ev-plusone';
    p1.textContent = '+1';
    p1.setAttribute('data-t', String(Date.now()));
    pill.appendChild(p1);
    var gone = false;
    var kill = function () { if (gone) return; gone = true; if (p1.parentNode) p1.parentNode.removeChild(p1); };
    p1.addEventListener('animationend', kill);
    setTimeout(kill, 1200);
    setTimeout(function () { pill.classList.remove('ev-pulse'); }, 600);
    try { localStorage.setItem('evhelp:' + key, '1'); } catch (e3) {}
    try { var up = rev.querySelector('.jdgm-rev__votes .jdgm-vote-up, .jdgm-rev__votes [class*=up]'); if (up) up.click(); } catch (e4) {}
  });


  var DE_MAP = [
    ['Sort by', 'Sortieren nach'],
    ['Write a review', 'Bewertung schreiben'],
    ['Write a Review', 'Bewertung schreiben'],
    ['Schreiben Sie die erste Bewertung', 'Schreib die erste Bewertung'],
    ['Schreiben Sie eine Bewertung', 'Bewertung schreiben'],
    ['Be the first to write a review', 'Schreib die erste Bewertung'],
    ['Most Recent', 'Neueste'],
    ['Highest Rating', 'Beste Bewertung'],
    ['Lowest Rating', 'Schlechteste Bewertung'],
    ['Only Pictures', 'Nur mit Foto'],
    ['Pictures First', 'Fotos zuerst'],
    ['Videos First', 'Videos zuerst'],
    ['Most Helpful', 'Hilfreichste'],
    ['Was this helpful?', 'War das hilfreich?'],
    ['Verified Purchase', 'Verifizierter Kauf'],
    ['Reviews', 'Bewertungen'],
    ['Review', 'Bewertung'],
    ['Cancel', 'Abbrechen'],
    ['Submit', 'Absenden'],
    ['Load More', 'Mehr anzeigen'],
    ['Ihre', 'Deine'], ['Ihnen', 'dir'], ['Ihr Name', 'Dein Name']
  ];

  function germanizeIn(root) {
    if (!root) return;
    var opts = root.querySelectorAll('option');
    for (var i = 0; i < opts.length; i++) {
      for (var m = 0; m < DE_MAP.length; m++) {
        if (opts[i].textContent.trim() === DE_MAP[m][0]) opts[i].textContent = DE_MAP[m][1];
      }
    }
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (n.parentElement && n.parentElement.closest('.jdgm-rev__body, .jdgm-rev__title, .jdgm-rev__author')) continue;
      var t = n.nodeValue;
      if (!t || !t.trim()) continue;
      for (var k = 0; k < DE_MAP.length; k++) {
        if (t.trim() === DE_MAP[k][0]) { n.nodeValue = t.replace(DE_MAP[k][0], DE_MAP[k][1]); break; }
      }
    }
    var labelled = root.querySelectorAll('[aria-label],[placeholder],[title]');
    for (var q = 0; q < labelled.length; q++) {
      ['aria-label', 'placeholder', 'title'].forEach(function (attr) {
        var v = labelled[q].getAttribute(attr);
        if (!v) return;
        for (var z = 0; z < DE_MAP.length; z++) {
          if (v.trim() === DE_MAP[z][0]) labelled[q].setAttribute(attr, DE_MAP[z][1]);
        }
      });
    }
  }

  function germanize() {
    germanizeIn(document.querySelector('.jdgm-rev-widg'));
    germanizeIn(document.querySelector('.jdgm-form-wrapper'));
  }

  function zeroReviewBadges() {
    var badges = document.querySelectorAll('.jdgm-prev-badge');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (b.dataset.evZeroDone === '1') continue;
      var n = parseInt(b.getAttribute('data-number-of-reviews') || '0', 10);
      if (!isFinite(n) || n > 0) continue;
      b.dataset.evZeroDone = '1';
      b.innerHTML = '<span class="ev-jdgm-none" style="font-size:12px;color:#9a9a9a;font-weight:600;">Keine Bewertungen</span>';
    }
  }

  var mo = new MutationObserver(function () { enhance(); initTopPick(); styleSort(); buildGallery(); ensureAuthNote(); germanize(); zeroReviewBadges(); });
  function boot() {
    enhance();
    initTopPick();
    styleSort();
    buildGallery();
    ensureAuthNote();
    germanize();
    zeroReviewBadges();
    if (!window.__evZeroObs) {
      window.__evZeroObs = new MutationObserver(function () { zeroReviewBadges(); });
      window.__evZeroObs.observe(document.body, { childList: true, subtree: true });
    }
    var widg = document.querySelector('.jdgm-rev-widg');
    if (widg) mo.observe(widg, { childList: true, subtree: true });
    else setTimeout(boot, 800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
